/** @jsx jsx */
import React, { type ReactNode } from 'react';

import { css, jsx } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useShowUFOSegmentsState } from './hooks/useShowUFOSegmentsState.tsx';

type Props = {
	name: string;
	children: ReactNode;
	mode?: 'list' | 'single';
	isThirdPartySegment?: boolean;
};
/**
 * @description Used only on staging with jira_highlight_ufo_segments fg to see ufo segments
 *  Do not import directly!! only import behind importCond so that it does not have impact in production
 */
export const DEBUGUFOSegmentHighlight = (props: Props) => {
	const [showUFOSegments] = useShowUFOSegmentsState();

	// Do nothing
	if (!showUFOSegments) {
		return props.children;
	}
	if (props.isThirdPartySegment) {
		return <ThirdPartyUfoSegmentWrapperWithHighlight {...props} />;
	}
	return <UfoSegmentWrapperWithHighlight {...props} />;
};

/**
 * used only on staging with jira_highlight_ufo_segments fg to see ufo segments
 */
const ThirdPartyUfoSegmentWrapperWithHighlight = ({ children, name }: Props) => {
	const thirdPartySegmentName = `thirdPartySegment ${name}`;
	return (
		<Box xcss={borderStylesBlack}>
			<span css={textStylesBlack}>{thirdPartySegmentName}</span>
			{children}
		</Box>
	);
};

/**
 * used only on staging with jira_highlight_ufo_segments fg to see ufo segments
 */
const UfoSegmentWrapperWithHighlight = ({ children, name }: Props) => {
	return (
		<Box xcss={borderStylesBlue}>
			<span css={textStylesBlue}>{name}</span>
			{children}
		</Box>
	);
};

const textStylesBlue = css({
	position: 'relative',
	color: token('color.text.accent.blue'),
	display: 'flex',
	justifyContent: 'center',
});

const borderStylesBlue = xcss({
	border: '2px solid blue',
	borderRadius: 'radius.small',
	padding: 'space.100',
});

const textStylesBlack = css({
	position: 'relative',
	color: token('color.text'),
	display: 'flex',
	justifyContent: 'center',
});

const borderStylesBlack = xcss({
	border: '2px solid black',
	borderRadius: 'radius.small',
	padding: 'space.100',
});
